import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const InstitucionalSection = () => {
  return (
    <section className="bg-neutral-50 py-14 lg:py-32">
      <div className="max-w-5xl mx-auto px-4 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-10 lg:mb-16"
        >
          <div className="w-36 h-36 lg:w-48 lg:h-48 mx-auto mb-6 lg:mb-8 rounded-full bg-white shadow-card overflow-hidden">
            <img
              src="https://static.readdy.ai/image/c4e06bad978995a8efa8373b87e2590a/a2f84fe7efe2b745ced843cd555a9d27.png"
              alt="Engenheiro Responsável"
              className="w-full h-full object-cover object-top"
            />
          </div>

          <h3 className="font-display font-bold text-2xl lg:text-3xl text-primary mb-2">
            Eng. Rodrigo Naldi
          </h3>
          <p className="text-sm lg:text-base text-neutral-600 mb-2 px-2">
            CREA-SP 5071305786 | Engenheiro Civil e Engenheiro de Segurança do Trabalho
          </p>
          <p className="text-neutral-600 text-xs lg:text-sm mb-6 lg:mb-8">
            Especialista em Engenharia de Prevenção de Incêndios e Engenharia de Avaliações e Perícias
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2, duration: 0.6 }}
          className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8 mb-8 lg:mb-12"
        >
          <div className="text-sm lg:text-lg text-neutral-700 leading-relaxed space-y-3 lg:space-y-4">
            <p>
              A <strong className="text-primary">Engeporto Engenharia e Serviços</strong> nasceu da necessidade de oferecer soluções técnicas especializadas com excelência e comprometimento nas Regiões Metropolitanas de Sorocaba e Campinas.
            </p>
            <p>
              Com mais de 10 anos de experiência, nossa equipe é formada por engenheiros altamente qualificados e especializados nas principais normas técnicas brasileiras.
            </p>
          </div>

          <div className="text-sm lg:text-lg text-neutral-700 leading-relaxed space-y-3 lg:space-y-4">
            <p className="italic text-accent border-l-4 border-accent pl-4 lg:pl-6">
              &quot;Nossa missão é garantir segurança, conformidade e tranquilidade aos nossos clientes através de soluções técnicas de alto padrão e atendimento personalizado.&quot;
            </p>
            <p>
              Atuamos com foco em três pilares fundamentais: Prevenção de Incêndio, Segurança do Trabalho e Perícias Técnicas, oferecendo um portfólio completo de serviços.
            </p>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.4, duration: 0.6 }}
          className="flex flex-wrap items-center justify-center gap-4 lg:gap-8 mb-8 lg:mb-12"
        >
          <div className="flex items-center gap-3 px-5 lg:px-6 py-3 bg-white rounded-xl shadow-sm">
            <img
              src="https://static.readdy.ai/image/c4e06bad978995a8efa8373b87e2590a/67ab712f1d949d9d0e8df825c6e65a10.png"
              alt="CREA-SP Registro Nº 2511699"
              className="h-8 lg:h-10 w-auto object-contain"
            />
          </div>
          <div className="flex items-center gap-3 px-5 lg:px-6 py-3 bg-white rounded-xl shadow-sm">
            <img
              src="https://static.readdy.ai/image/c4e06bad978995a8efa8373b87e2590a/d241ace788346d0f455bb4dc13eabbe5.png"
              alt="ABNT - Associação Brasileira de Normas Técnicas"
              className="h-8 lg:h-10 w-auto object-contain"
            />
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.6, duration: 0.6 }}
          className="text-center"
        >
          <Link
            to="/institucional"
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            className="inline-flex items-center gap-2 bg-primary text-white px-6 lg:px-8 py-3 lg:py-4 rounded-full text-sm lg:text-base font-semibold hover:bg-primary-light transition-all whitespace-nowrap"
          >
            Conheça Nossa História
            <i className="ri-arrow-right-line"></i>
          </Link>
        </motion.div>
      </div>
    </section>
  );
};

export default InstitucionalSection;
